import { defineStore } from 'pinia'

/**
 * Replaces EventBus for all global dialog management.
 *
 * Open a dialog:
 *   modal.openCustomer({ id: 123 })
 *
 * In dialog component — react to open:
 *   watch(() => modal.customer.visible, (val) => { if (val) loadData(modal.customer.data) })
 *
 * Selection result (replaces EventBus.$emit('customerSelected', row)):
 *   modal.resolveCustomer(row)   ← called inside CustomerDialog on select
 *
 * Consuming dialog listens:
 *   watch(() => modal.customer.selected, (val) => { if (val) handleSelect(val) })
 */
export const useModalStore = defineStore('modal', {
  state: () => ({
    customer: { visible: false, data: null, selected: null },
    vendor: { visible: false, data: null, selected: null },
    employee: { visible: false, data: null, selected: null },
    product: { visible: false, data: null, selected: null },
    sku: { visible: false, data: null, selected: null },
    smith: { visible: false, data: null, selected: null },
    cashTransaction: { visible: false, data: null },
    itemTransaction: { visible: false, data: null },
    pandyTransferItem: { visible: false, data: null },
    pandyTransferItemRecRet: { visible: false, data: null },
    trackRecord: { visible: false, data: null }
  }),

  actions: {
    openCustomer(data = null) { this.customer = { visible: true, data, selected: null } },
    closeCustomer() { this.customer.visible = false },
    resolveCustomer(row) { this.customer.selected = row; this.customer.visible = false },

    openVendor(data = null) { this.vendor = { visible: true, data, selected: null } },
    closeVendor() { this.vendor.visible = false },
    resolveVendor(row) { this.vendor.selected = row; this.vendor.visible = false },

    openEmployee(data = null) { this.employee = { visible: true, data, selected: null } },
    closeEmployee() { this.employee.visible = false },
    resolveEmployee(row) { this.employee.selected = row; this.employee.visible = false },

    openProduct(data = null) { this.product = { visible: true, data, selected: null } },
    closeProduct() { this.product.visible = false },
    resolveProduct(row) { this.product.selected = row; this.product.visible = false },

    openSku(data = null) { this.sku = { visible: true, data, selected: null } },
    closeSku() { this.sku.visible = false },
    resolveSku(row) { this.sku.selected = row; this.sku.visible = false },

    openSmith(data = null) { this.smith = { visible: true, data, selected: null } },
    closeSmith() { this.smith.visible = false },
    resolveSmith(row) { this.smith.selected = row; this.smith.visible = false },

    openCashTransaction(data = null) { this.cashTransaction = { visible: true, data } },
    closeCashTransaction() { this.cashTransaction.visible = false },

    openItemTransaction(data = null) { this.itemTransaction = { visible: true, data } },
    closeItemTransaction() { this.itemTransaction.visible = false },

    openPandyTransferItem(data = null) { this.pandyTransferItem = { visible: true, data } },
    closePandyTransferItem() { this.pandyTransferItem.visible = false },

    openPandyTransferItemRecRet(data = null) { this.pandyTransferItemRecRet = { visible: true, data } },
    closePandyTransferItemRecRet() { this.pandyTransferItemRecRet.visible = false },

    openTrackRecord(data = null) { this.trackRecord = { visible: true, data } },
    closeTrackRecord() { this.trackRecord.visible = false }
  }
})
